// src/components/Shared/VisualDiff.tsx
import React, { useState } from 'react';

interface VisualDiffProps {
    originalUrl: string;
    compressedUrl: string;
    fileName?: string;
}

const VisualDiff: React.FC<VisualDiffProps> = ({ originalUrl, compressedUrl }) => {
    const [sliderPosition, setSliderPosition] = useState<number>(50);

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        setSliderPosition(Math.max(0, Math.min(100, x)));
    };

    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const touch = e.touches[0];
        const x = ((touch.clientX - rect.left) / rect.width) * 100;
        setSliderPosition(Math.max(0, Math.min(100, x)));
    };

    return (
        <div className="w-full my-5 text-center">
            <div
                className="relative w-full max-w-[800px] mx-auto aspect-video overflow-hidden rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.15)] bg-slate-100 cursor-col-resize select-none max-[800px]:aspect-auto max-[800px]:min-h-[250px] dark:bg-slate-800"
                onMouseMove={handleMouseMove}
                onTouchMove={handleTouchMove}
            >
                <div className="w-full h-full">
                    <img
                        src={compressedUrl}
                        alt="Compressed"
                        className="absolute top-0 left-0 w-full h-full object-contain block max-[800px]:w-full max-[800px]:h-auto w-[800px] h-[450px]"
                    />
                    <span className="absolute bottom-3 right-3 px-3 py-1 bg-black/60 text-white rounded text-xs font-semibold uppercase z-10 transition-opacity">After</span>
                </div>

                <div
                    className="absolute top-0 left-0 h-full overflow-hidden border-r-2 border-white"
                    style={{ width: `${sliderPosition}%` }}
                >
                    <img
                        src={originalUrl}
                        alt="Original"
                        className="absolute top-0 left-0 h-full object-contain block max-[800px]:w-full max-[800px]:h-auto w-[100vw] max-w-[800px] h-[450px]"
                    />
                    <span className="absolute bottom-3 left-3 px-3 py-1 bg-black/60 text-white rounded text-xs font-semibold uppercase z-10">Before</span>
                </div>

                <div
                    className="absolute top-0 bottom-0 z-20 pointer-events-none"
                    style={{ left: `${sliderPosition}%` }}
                >
                    <div className="absolute top-0 bottom-0 w-[2px] bg-white -left-[1px]"></div>
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 bg-primary border-[3px] border-white rounded-full flex items-center justify-center text-white shadow-[0_4px_10px_rgba(0,0,0,0.3)]">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="15 18 9 12 15 6"></polyline>
                            <polyline points="9 18 3 12 9 6"></polyline>
                            <polyline points="21 18 15 12 21 6"></polyline>
                        </svg>
                    </div>
                </div>
            </div>
            <p className="mt-3 text-sm text-slate-500 italic dark:text-slate-400">Drag the slider to compare quality</p>
        </div>
    );
};

export default VisualDiff;
